import { useQuery, UseQueryOptions } from 'react-query';
import * as SDK from '@replai-platform/sdk';
import * as provider from '../../api/provider';

const getAssetWeekdayPerformance = async (requestParams: SDK.GetAssetWeekdayPerformanceRequest, assetId: SDK.UUID) => {
  const res = await provider.getJson<object, SDK.GetAssetWeekdayPerformanceResponse>(
    `${SDK.BASE_URL()}/assets/${assetId}/weekdayperformance?${SDK.convertRequestToQueryParams(requestParams)}`
  );
  return res;
};

export default function useAssetWeekdayPerformance(
  assetId: SDK.UUID,
  requestParams: SDK.GetAssetWeekdayPerformanceRequest,
  options?: UseQueryOptions<SDK.GetAssetWeekdayPerformanceResponse>
) {
  return useQuery(
    ['asset-weekdayperformance', assetId, requestParams],
    () => getAssetWeekdayPerformance(requestParams, assetId),
    options
  );
}
